
const CHEMISTRY_EXPERIMENTS = {
6: [
  {
    id: "baking_soda_vinegar_volcano",
    title: "Baking Soda + Vinegar - Effervescence",
    description: "Simple acid-base reaction producing CO₂ gas.",
    apparatus: "beaker",
    reagents: [
      { id: "baking_soda", name: "Baking Soda (Sodium Bicarbonate)", color: "#708993", state: "solid", icon: "powder" },
      { id: "vinegar", name: "Vinegar (Acetic Acid 5%)", color: "#ef4444", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Place baking soda in a small beaker or volcano model.",
      "Pour vinegar slowly onto baking soda.",
      "Observe foaming/CO₂ bubbles and overflow."
    ],
    outputs: { vinegar: "Produces CO₂ gas and water with effervescence." },
    effects: [{ id: "bubbles", name: "Effervescence", color: "#3396D3", icon: "bubbles" }],
  },
  {
    id: "salt_water_evaporation",
    title: "Evaporation of Salt Water",
    description: "Demonstrate how water evaporates leaving salt crystals.",
    apparatus: "beaker",
    reagents: [
      { id: "salt_water", name: "Salt Water", color: "#60a5fa", state: "liquid", icon: "droplet" }
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Pour salt water into a beaker.",
      "Heat the beaker gently until water evaporates.",
      "Observe salt crystals left behind."
    ],
    outputs: { salt_water: "Water evaporates, salt remains." },
    effects: [{ id: "crystal", name: "Salt Crystals Form", color: "#CD2C58", icon: "crystal" }],
  },
  {
    id: "candle_in_jar",
    title: "Oxygen Requirement for Burning",
    description: "Show that oxygen is needed for combustion.",
    apparatus: "beaker",
    reagents: [
      { id: "candle", name: "Small Candle", color: "#fde68a", state: "solid", icon: "fire" },
      { id: "jar", name: "Glass Jar", color: "#9ca3af", state: "solid", icon: "flask" }
    ],
    steps: [
      "Light a candle and place it on a plate.",
      "Cover it with an inverted jar.",
      "Observe how the flame extinguishes after a few seconds."
    ],
    outputs: { candle: "Flame goes out when oxygen is used up." },
    effects: [{ id: "fire", name: "Combustion Stops", color: "#f87171", icon: "fire" }],
  },
  {
    id: "oil_water_mixture",
    title: "Oil and Water Don’t Mix",
    description: "Demonstrate immiscibility of oil and water.",
    apparatus: "beaker",
    reagents: [
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
      { id: "oil", name: "Cooking Oil", color: "#facc15", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Pour water into a beaker.",
      "Add a small amount of oil.",
      "Observe the oil floating on top."
    ],
    outputs: { oil: "Oil floats above water — immiscible liquids." },
    effects: [{ id: "layer", name: "Layer Formation", color: "#fcd34d", icon: "flask" }],
  },
  {
    id: "sugar_dissolving",
    title: "Dissolving of Sugar in Water",
    description: "Observe solubility of sugar in water.",
    apparatus: "beaker",
    reagents: [
      { id: "sugar", name: "Sugar", color: "#fef9c3", state: "solid", icon: "powder" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Add sugar to water and stir.",
      "Observe the sugar disappearing as it dissolves."
    ],
    outputs: { sugar: "Sugar dissolves — forms homogeneous solution." },
    effects: [{ id: "dissolution", name: "Dissolution", color: "#a5b4fc", icon: "bottle" }],
  },
  {
    id: "sinking_floating",
    title: "Sinking and Floating Objects",
    description: "Study density difference by observing sinking and floating objects.",
    apparatus: "beaker",
    reagents: [
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
      { id: "objects", name: "Various Objects (Stone, Plastic, Wood)", color: "#9ca3af", state: "solid", icon: "ingot" }
    ],
    steps: [
      "Fill beaker with water.",
      "Drop different objects one by one.",
      "Observe which float and which sink."
    ],
    outputs: { water: "Objects with lower density float; higher density sink." },
    effects: [{ id: "density", name: "Float or Sink", color: "#cbd5e1", icon: "beaker" }],
  },
  {
    id: "rusting_demo",
    title: "Rusting of Iron (Basic Demo)",
    description: "Show oxidation of iron nails in water and air.",
    apparatus: "beaker",
    waitTime: 20,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "water", name: "Water", color: "#60a5fa", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Place iron nail in water for several days.",
      "Observe reddish-brown rust forming."
    ],
    outputs: { iron: "Iron reacts with oxygen and moisture to form rust." },
    effects: [{ id: "colorChange", name: "Rust Formation", color: "#b45309", icon: "crystal" }],
  },
  {
    id: "melting_ice",
    title: "Melting of Ice",
    description: "Observe melting of ice cubes at room temperature.",
    apparatus: "beaker",
    reagents: [
      { id: "ice", name: "Ice Cubes", color: "#bfdbfe", state: "solid", icon: "crystal" }
    ],
    steps: [
      "Place ice cubes in a beaker.",
      "Observe them melting over time."
    ],
    outputs: { ice: "Solid turns into liquid water." },
    effects: [{ id: "phaseChange", name: "Melting", color: "#60a5fa", icon: "lowtemp" }],
  },
  {
    id: "filtering_mixture",
    title: "Filtration of Muddy Water",
    description: "Demonstrate separation of insoluble solids from liquids.",
    apparatus: "flask",
    reagents: [
      { id: "muddy_water", name: "Muddy Water", color: "#a16207", state: "liquid", icon: "bottle" },
      { id: "filter_paper", name: "Filter Paper", color: "#f5f5f4", state: "solid", icon: "flask" }
    ],
    steps: [
      "Pour muddy water through filter paper.",
      "Collect clear water below."
    ],
    outputs: { muddy_water: "Impurities trapped — clear filtrate collected." },
    effects: [{ id: "filtration", name: "Filtration", color: "#84cc16", icon: "flask" }],
  },
  {
    id: "limewater_co2",
    title: "Carbon Dioxide Test using Limewater",
    description: "Detect CO₂ gas by turning limewater milky.",
    apparatus: "test_tube",
    reagents: [
      { id: "limewater", name: "Limewater (Calcium Hydroxide)", color: "#e0f2fe", state: "liquid", icon: "droplet" },
      { id: "co2", name: "Carbon Dioxide Gas", color: "#9ca3af", state: "gas", icon: "bubbles" }
    ],
    steps: [
      "Bubble CO₂ gas through limewater.",
      "Observe it turning milky."
    ],
    outputs: { limewater: "CO₂ + Ca(OH)₂ → CaCO₃ (milky)" },
    effects: [{ id: "colorChange", name: "Milky Formation", color: "#a5b4fc", icon: "crystal" }],
  },
],

7: [
  {
    id: "acid_on_metal",
    title: "Action of Acid on Metal",
    description: "Demonstrate hydrogen gas release when acid reacts with metal.",
    apparatus: "test_tube",
    reagents: [
      { id: "metal", name: "Zinc Granules", color: "#a3a3a3", state: "solid", icon: "ingot" },
      { id: "acid", name: "Dilute HCl", color: "#ef4444", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Add zinc granules to a test tube.",
      "Pour dilute HCl slowly.",
      "Observe effervescence and gas evolution."
    ],
    outputs: { metal: "Zinc reacts with HCl to produce hydrogen gas." },
    effects: [{ id: "bubbles", name: "Effervescence", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "acid_base_indicator",
    title: "Effect of Acid and Base on Indicators",
    description: "Study color change of indicators with acids and bases.",
    apparatus: "beaker",
    reagents: [
      { id: "acid", name: "Dilute HCl", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH", color: "#4ade80", state: "liquid", icon: "droplet" },
      { id: "litmus", name: "Litmus Solution", color: "#6366f1", state: "liquid", icon: "bottle" }
    ],
    steps: [
      "Add litmus to acid and observe red color.",
      "Add litmus to base and observe blue color."
    ],
    outputs: { litmus: "Acid turns blue litmus red; base turns red litmus blue." },
    effects: [{ id: "colorChange", name: "Indicator Color Change", color: "#a855f7", icon: "crystal" }],
  },
  {
    id: "neutralization_reaction",
    title: "Neutralization of Acid and Base",
    description: "Demonstrate neutralization and salt formation.",
    apparatus: "beaker",
    reagents: [
      { id: "acid", name: "Dilute H₂SO₄", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH", color: "#4ade80", state: "liquid", icon: "droplet" },
      { id: "indicator", name: "Phenolphthalein", color: "#a855f7", state: "liquid", icon: "bottle" }
    ],
    steps: [
      "Add acid and indicator to a beaker.",
      "Add base dropwise until color changes.",
      "Observe pink color disappearance."
    ],
    outputs: { indicator: "Color disappears as solution becomes neutral." },
    effects: [{ id: "colorChange", name: "Color Change", color: "#f472b6", icon: "crystal" }],
  },
  {
    id: "burning_magnesium",
    title: "Burning of Magnesium Ribbon",
    description: "Observe bright flame and formation of magnesium oxide.",
    apparatus: "test_tube",
    reagents: [
      { id: "magnesium", name: "Magnesium Ribbon", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "oxygen", name: "Oxygen (Air)", color: "#9ca3af", state: "gas", icon: "bubbles" }
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Clean magnesium ribbon and hold with tongs.",
      "Burn it in flame.",
      "Observe white ash formed."
    ],
    outputs: { magnesium: "Magnesium + Oxygen → Magnesium Oxide (white ash)." },
    effects: [{ id: "fire", name: "Combustion", color: "#f87171", icon: "fire" }],
  },
  {
    id: "sublimation_camphor",
    title: "Sublimation of Camphor",
    description: "Show solid changing directly into vapors on heating.",
    apparatus: "flask",
    reagents: [
      { id: "camphor", name: "Camphor", color: "#824857", state: "solid", icon: "powder" }
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Place camphor in a china dish.",
      "Heat gently and cover with funnel.",
      "Observe crystals forming on cooler parts."
    ],
    outputs: { camphor: "Camphor sublimes forming crystals on funnel walls." },
    effects: [{ id: "smoke", name: "Sublimation Fumes", color: "#d1d5db", icon: "smoke" }],
  },
  {
    id: "displacement_reaction",
    title: "Displacement Reaction of Iron and Copper Sulphate",
    description: "Show iron displacing copper from CuSO₄ solution.",
    apparatus: "beaker",
    waitTime: 10,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "cuso4", name: "Copper Sulphate Solution", color: "#3b82f6", state: "liquid", icon: "bottle" }
    ],
    steps: [
      "Dip clean iron nail in copper sulphate solution.",
      "Leave it for 15–20 minutes.",
      "Observe brown deposit on nail and solution color change."
    ],
    outputs: { iron: "Iron displaces copper; FeSO₄ solution and copper formed." },
    effects: [{ id: "colorChange", name: "Color Change", color: "#3b82f6", icon: "crystal" }],
  },
  {
    id: "crystallization_salt",
    title: "Crystallization of Salt from Solution",
    description: "Form salt crystals from concentrated salt solution.",
    apparatus: "flask",
    waitTime: 12,
    reagents: [
      { id: "salt_solution", name: "Saturated Salt Solution", color: "#cbd5e1", state: "liquid", icon: "droplet" }
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Heat salt solution until saturated.",
      "Cool it slowly to form crystals."
    ],
    outputs: { salt_solution: "White salt crystals formed on cooling." },
    effects: [{ id: "crystal", name: "Crystal Formation", color: "#a5b4fc", icon: "crystal" }],
  },
  {
    id: "burning_candle_co2",
    title: "Production of CO₂ by Candle Burning",
    description: "Detect CO₂ by turning limewater milky.",
    apparatus: "beaker",
    reagents: [
      { id: "candle", name: "Candle", color: "#fde68a", state: "solid", icon: "fire" },
      { id: "limewater", name: "Limewater", color: "#dbeafe", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Burn candle near limewater setup.",
      "Bubble produced gases through limewater.",
      "Observe limewater turning milky."
    ],
    outputs: { limewater: "CO₂ produced during combustion turns limewater milky." },
    effects: [{ id: "colorChange", name: "Limewater Milky", color: "#fbbf24", icon: "crystal" }],
  },
  {
    id: "mixture_separation",
    title: "Separation of Sand and Salt Mixture",
    description: "Demonstrate filtration and evaporation to separate components.",
    apparatus: "flask",
    reagents: [
      { id: "mixture", name: "Sand and Salt Mixture", color: "#facc15", state: "solid", icon: "powder" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" }
    ],
    tools: [{ id: "filter_paper", name: "Filter Paper", color: "#f5f5f4", state: "solid", icon: "flask" }],
    steps: [
      "Add water to mixture and stir.",
      "Filter to separate sand.",
      "Evaporate filtrate to recover salt."
    ],
    outputs: { mixture: "Sand separated by filtration, salt by evaporation." },
    effects: [{ id: "filtration", name: "Filtration Process", color: "#84cc16", icon: "flask" }],
  },
  {
    id: "oxidation_brightness",
    title: "Brightness due to Oxidation",
    description: "Observe iron nail rusting and color change on exposure.",
    apparatus: "beaker",
    waitTime: 20,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "air", name: "Air (Oxygen)", color: "#9ca3af", state: "gas", icon: "bubbles" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" }
    ],
    steps: [
      "Expose iron nail to moist air.",
      "Observe change in color and rust formation."
    ],
    outputs: { iron: "Iron oxidizes to form rust (Fe₂O₃·xH₂O)." },
    effects: [{ id: "colorChange", name: "Rust Formation", color: "#b45309", icon: "crystal" }],
  },
],

8: [
  {
    id: "metal_nonmetal",
    title: "Reaction of Metals and Non-Metals",
    description: "Study how metals react with acids and non-metals.",
    apparatus: "test_tube",
    reagents: [
      { id: "metal", name: "Zinc", color: "#a3a3a3", state: "solid", icon: "ingot" },
      { id: "acid", name: "Dilute HCl", color: "#ef4444", state: "liquid", icon: "droplet" },
    ],
    steps: [
      "Add zinc to a test tube.",
      "Pour dilute HCl slowly.",
      "Observe hydrogen gas bubbles forming.",
    ],
    outputs: { metal: "Zinc reacts with HCl releasing hydrogen gas." },
    effects: [{ id: "bubbles", name: "Effervescence", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "combustion",
    title: "Combustion Reaction",
    description: "Demonstrate the reaction of a substance with oxygen.",
    apparatus: "beaker",
    reagents: [
      { id: "fuel", name: "Ethanol", color: "#f59e0b", state: "liquid", icon: "bottle" },
      { id: "oxygen", name: "Oxygen (Air)", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    steps: [
      "Pour ethanol in a watch glass.",
      "Expose to flame.",
      "Observe combustion (blue flame).",
    ],
    outputs: { fuel: "Ethanol burns producing CO₂ and H₂O." },
    effects: [{ id: "fire", name: "Blue Flame", color: "#fb923c", icon: "fire" }],
  },
  {
    id: "crystallization_cuso4",
    title: "Crystallization of Copper Sulphate",
    description: "Preparation of pure copper sulphate crystals.",
    apparatus: "flask",
    waitTime: 12,
    reagents: [
      { id: "impure_cuso4", name: "Impure Copper Sulphate", color: "#3b82f6", state: "solid", icon: "powder" },
      { id: "water", name: "Distilled Water", color: "#60a5fa", state: "liquid", icon: "droplet" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Dissolve impure CuSO₄ in hot water.",
      "Filter impurities and evaporate to saturation.",
      "Cool to form blue CuSO₄ crystals.",
    ],
    outputs: { impure_cuso4: "Bright blue CuSO₄ crystals formed on cooling." },
    effects: [{ id: "crystal", name: "Blue Crystals", color: "#60a5fa", icon: "crystal" }],
  },
  {
    id: "carbon_dioxide_test",
    title: "Test for Carbon Dioxide Gas",
    description: "Pass CO₂ through limewater and observe change.",
    apparatus: "test_tube",
    reagents: [
      { id: "limewater", name: "Limewater", color: "#bae6fd", state: "liquid", icon: "droplet" },
      { id: "co2", name: "Carbon Dioxide Gas", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    steps: ["Bubble CO₂ through limewater.", "Observe it turning milky."],
    outputs: { co2: "CO₂ + Ca(OH)₂ → CaCO₃ (milky precipitate)." },
    effects: [{ id: "colorChange", name: "Milky Formation", color: "#a5b4fc", icon: "crystal" }],
  },
  {
    id: "decomposition_heating",
    title: "Thermal Decomposition of Calcium Carbonate",
    description: "Observe lime formation by heating CaCO₃.",
    apparatus: "test_tube",
    reagents: [
      { id: "caco3", name: "Calcium Carbonate", color: "#824857", state: "solid", icon: "powder" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Heat calcium carbonate in a test tube.",
      "Observe gas bubbles and residue formation.",
    ],
    outputs: { caco3: "CaCO₃ → CaO + CO₂." },
    effects: [{ id: "bubbles", name: "Gas Evolution", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "electrolysis_water",
    title: "Electrolysis of Water",
    description: "Decomposition of water into hydrogen and oxygen.",
    apparatus: "flask",
    reagents: [
      { id: "water", name: "Water with Acid", color: "#3b82f6", state: "liquid", icon: "droplet" },
    ],
    tools: [
      { id: "electrodes", name: "Electrodes", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "electricity", name: "Power Source", color: "#f97316", state: "energy", icon: "energy" },
    ],
    steps: [
      "Add water into an electrolysis cell.",
      "Switch on power supply.",
      "Collect gases at electrodes.",
    ],
    outputs: { electricity: "Hydrogen gas at cathode, oxygen at anode." },
    effects: [{ id: "bubbles", name: "Gas Bubbles at Electrodes", color: "#212a50", icon: "bubbles" }],
  },
  {
    id: "neutralization",
    title: "Neutralization Reaction",
    description: "Mix acid and base to observe neutralization.",
    apparatus: "beaker",
    reagents: [
      { id: "acid", name: "HCl", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH", color: "#4ade80", state: "liquid", icon: "droplet" },
    ],
    steps: ["Add acid", "Add base", "Observe salt and water formation."],
    outputs: { base: "Salt + Water formed (neutralization)." },
    effects: [{ id: "colorChange", name: "Indicator Color Change", color: "#a855f7", icon: "crystal" }],
  },
  {
    id: "burning_sulphur",
    title: "Burning of Sulphur in Air",
    description: "Show formation of acidic gas when sulphur burns.",
    apparatus: "test_tube",
    reagents: [
      { id: "sulphur", name: "Sulphur Powder", color: "#facc15", state: "solid", icon: "powder" },
      { id: "oxygen", name: "Oxygen", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Heat sulphur in a spoon until it catches fire.",
      "Insert into test tube containing moist litmus paper.",
      "Observe color change to red (acidic gas).",
    ],
    outputs: { sulphur: "Sulphur burns forming SO₂ gas (acidic nature)." },
    effects: [{ id: "fire", name: "Combustion", color: "#f87171", icon: "fire" }],
  },
  {
    id: "chemical_change_demo",
    title: "Observation of Chemical Change",
    description: "Mix vinegar and baking soda and observe fizzing.",
    apparatus: "beaker",
    reagents: [
      { id: "baking_soda", name: "Baking Soda", color: "#824857", state: "solid", icon: "powder" },
      { id: "vinegar", name: "Vinegar", color: "#ef4444", state: "liquid", icon: "droplet" },
    ],
    steps: [
      "Add baking soda to beaker.",
      "Pour vinegar on top.",
      "Observe bubbling CO₂ gas.",
    ],
    outputs: { vinegar: "CO₂ produced, temperature drops — endothermic." },
    effects: [{ id: "bubbles", name: "Effervescence", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "sublimation_ammonium_chloride",
    title: "Sublimation of Ammonium Chloride",
    description: "Observe sublimation upon heating.",
    apparatus: "test_tube",
    reagents: [
      { id: "ammonium", name: "Ammonium Chloride", color: "#9ca3af", state: "solid", icon: "powder" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Place ammonium chloride in a test tube.",
      "Heat gently and observe white fumes.",
      "Crystals form on cooler surface.",
    ],
    outputs: { ammonium: "NH₄Cl sublimates forming white vapors." },
    effects: [{ id: "smoke", name: "White Vapors", color: "#2c404c", icon: "crystal" }],
  },
],

9: [
  {
    id: "electrolysis",
    title: "Electrolysis of Water",
    description: "Decomposition of water using electric current.",
    apparatus: "flask",
    reagents: [
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
    ],
    tools: [
      { id: "electricity", name: "Power Source", color: "#f97316", state: "energy", icon: "energy" },
      { id: "electrodes", name: "Electrodes", color: "#9ca3af", state: "solid", icon: "ingot" },
    ],
    steps: [
      "Add water into the container.",
      "Switch on electric current.",
      "Observe gas bubbles at electrodes.",
    ],
    outputs: { electricity: "Hydrogen and oxygen gases formed at electrodes." },
    effects: [{ id: "bubbles", name: "Gas Bubbles", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "neutralization",
    title: "Neutralization Reaction",
    description: "Mix acid and base to observe neutralization.",
    apparatus: "beaker",
    reagents: [
      { id: "acid", name: "HCl", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH", color: "#4ade80", state: "liquid", icon: "droplet" },
    ],
    steps: ["Add acid", "Add base", "Observe color change with indicator."],
    outputs: {
      base: "Salt + Water formed during neutralization.",
    },
    effects: [{ id: "colorChange", name: "Indicator Color Change", color: "#a855f7", icon: "crystal" }],
  },
  {
    id: "rusting_iron",
    title: "Rusting of Iron",
    description: "Show oxidation of iron nails forming rust.",
    apparatus: "flask",
    waitTime: 20,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
      { id: "air", name: "Air (Oxygen)", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    steps: [
      "Keep an iron nail partly dipped in water.",
      "Observe formation of reddish-brown rust after a few days.",
    ],
    outputs: { iron: "Iron oxidizes to Fe₂O₃·xH₂O (rust)." },
    effects: [{ id: "colorChange", name: "Rust Formation", color: "#b45309", icon: "crystal" }],
  },
  {
    id: "reaction_acid_carbonate",
    title: "Reaction of Acid with Carbonate",
    description: "Show effervescence due to CO₂ formation.",
    apparatus: "test_tube",
    reagents: [
      { id: "acid", name: "Dilute HCl", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "carbonate", name: "Calcium Carbonate (Marble Chips)", color: "#212a50", state: "solid", icon: "powder" },
    ],
    steps: [
      "Add marble chips into test tube.",
      "Pour dilute HCl slowly.",
      "Observe effervescence due to CO₂.",
    ],
    outputs: { carbonate: "CO₂ gas released; limewater test confirms." },
    effects: [{ id: "bubbles", name: "Gas Evolution", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "combination_reaction",
    title: "Combination Reaction",
    description: "Show magnesium reacting with oxygen to form magnesium oxide.",
    apparatus: "test_tube",
    reagents: [
      { id: "magnesium", name: "Magnesium Ribbon", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "oxygen", name: "Oxygen", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Burn magnesium ribbon in oxygen.",
      "Observe bright light and white ash formation.",
    ],
    outputs: { magnesium: "Magnesium forms MgO (combination reaction)." },
    effects: [{ id: "fire", name: "Combustion", color: "#f87171", icon: "fire" }],
  },
  {
    id: "displacement_cu_fe",
    title: "Displacement Reaction (Fe + CuSO₄)",
    description: "Demonstrate single displacement of copper by iron.",
    apparatus: "beaker",
    waitTime: 10,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "cuso4", name: "Copper Sulphate Solution", color: "#3b82f6", state: "liquid", icon: "bottle" },
    ],
    steps: [
      "Dip iron nail into copper sulphate solution.",
      "Leave for a few minutes and observe color change.",
    ],
    outputs: { cuso4: "Blue color fades, copper deposits on nail." },
    effects: [{ id: "colorChange", name: "Color Change", color: "#3b82f6", icon: "crystal" }],
  },
  {
    id: "double_displacement",
    title: "Double Displacement Reaction",
    description: "Formation of precipitate in salt exchange reaction.",
    apparatus: "beaker",
    reagents: [
      { id: "na2so4", name: "Sodium Sulphate Solution", color: "#bae6fd", state: "liquid", icon: "droplet" },
      { id: "bacl2", name: "Barium Chloride Solution", color: "#fef9c3", state: "liquid", icon: "droplet" },
    ],
    steps: [
      "Mix Na₂SO₄ and BaCl₂ solutions.",
      "Observe formation of white precipitate.",
    ],
    outputs: { bacl2: "White BaSO₄ precipitate forms — double displacement reaction." },
    effects: [{ id: "precipitate", name: "White Precipitate", color: "#fde68a", icon: "crystal" }],
  },
  {
    id: "decomposition_heat",
    title: "Decomposition by Heating",
    description: "Decomposition of green ferrous sulphate crystals.",
    apparatus: "test_tube",
    reagents: [
      { id: "feso4", name: "Ferrous Sulphate Crystals", color: "#84cc16", state: "solid", icon: "crystal" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Heat ferrous sulphate crystals in test tube.",
      "Observe color change and gas evolution.",
    ],
    outputs: { feso4: "Turns brown, releasing SO₂ and SO₃ gases." },
    effects: [{ id: "colorChange", name: "Decomposition Change", color: "#a3e635", icon: "crystal" }],
  },
  {
    id: "precipitation_reaction",
    title: "Precipitation Reaction",
    description: "Formation of yellow precipitate of PbI₂.",
    apparatus: "beaker",
    reagents: [
      { id: "pbo", name: "Lead Nitrate Solution", color: "#fef9c3", state: "liquid", icon: "droplet" },
      { id: "ki", name: "Potassium Iodide Solution", color: "#fde047", state: "liquid", icon: "bottle" },
    ],
    steps: [
      "Mix both solutions in a beaker.",
      "Observe yellow precipitate formation.",
    ],
    outputs: { pbo: "Yellow PbI₂ formed." },
    effects: [{ id: "precipitate", name: "Yellow Precipitate", color: "#facc15", icon: "crystal" }],
  },
  {
    id: "corrosion_metals",
    title: "Corrosion of Metals",
    description: "Observe effect of moisture on corrosion.",
    apparatus: "flask",
    waitTime: 20,
    reagents: [
      { id: "iron", name: "Iron Nail", color: "#9ca3af", state: "solid", icon: "ingot" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
    ],
    steps: [
      "Expose iron nails to air and moisture.",
      "Observe rust after a few days.",
    ],
    outputs: { iron: "Fe₂O₃·xH₂O rust forms — corrosion demonstrated." },
    effects: [{ id: "colorChange", name: "Rust Formation", color: "#b45309", icon: "crystal" }],
  },
],

10: [
  {
    id: "acid_base",
    title: "Acid–Base Reaction",
    description: "Observe neutralization between acid and base using indicators.",
    apparatus: "beaker",
    reagents: [
      { id: "acid", name: "HCl (Acid)", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH (Base)", color: "#4ade80", state: "liquid", icon: "droplet" },
      { id: "indicator", name: "Phenolphthalein", color: "#a855f7", state: "liquid", icon: "bottle" },
    ],
    steps: [
      "Add 5ml HCl to the beaker.",
      "Add 5ml NaOH.",
      "Add 2 drops of phenolphthalein.",
      "Observe color change.",
    ],
    outputs: { indicator: "Turns pink in base, colorless when neutralized." },
    effects: [{ id: "colorChange", name: "Indicator Color Change", color: "#f472b6", icon: "crystal" }],
  },
  {
    id: "thermal_decomposition",
    title: "Thermal Decomposition of Calcium Carbonate",
    description: "Observe lime formation by heating CaCO₃.",
    apparatus: "test_tube",
    waitTime: 8,
    reagents: [{ id: "caco3", name: "Calcium Carbonate", color: "#824857", state: "solid", icon: "powder" }],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: ["Heat calcium carbonate in a test tube.", "Observe residue and gas formation."],
    outputs: { caco3: "CaCO₃ → CaO + CO₂." },
    effects: [{ id: "bubbles", name: "Gas Formation", color: "#2A3E4C", icon: "bubbles" }],
  },
  {
    id: "exothermic_reaction",
    title: "Exothermic Reaction Example",
    description: "Mixing quicklime with water releases heat.",
    apparatus: "beaker",
    reagents: [
      { id: "cao", name: "Quicklime (CaO)", color: "#2A3E4C", state: "solid", icon: "powder" },
      { id: "water", name: "Water", color: "#3b82f6", state: "liquid", icon: "droplet" },
    ],
    steps: ["Add small amount of water to quicklime.", "Observe heat and hissing sound."],
    outputs: { cao: "CaO + H₂O → Ca(OH)₂ + Heat." },
    effects: [{ id: "heat", name: "Heat Evolution", color: "#f97316", icon: "fire" }],
  },
  {
    id: "endothermic_reaction",
    title: "Endothermic Reaction Example",
    description: "Mix barium hydroxide and ammonium chloride — absorbs heat.",
    apparatus: "flask",
    reagents: [
      { id: "baoh2", name: "Barium Hydroxide", color: "#5179ac", state: "solid", icon: "powder" },
      { id: "nh4cl", name: "Ammonium Chloride", color: "#4f4559", state: "solid", icon: "powder" },
    ],
    steps: ["Mix both solids in a flask.", "Feel the flask — it becomes cold."],
    outputs: { nh4cl: "Endothermic reaction — heat absorbed." },
    effects: [{ id: "temperatureChange", name: "Cooling Effect", color: "#38bdf8", icon: "lowtemp" }],
  },
  {
    id: "sublimation_ammonium_chloride",
    title: "Sublimation of Ammonium Chloride",
    description: "Observe sublimation of ammonium chloride upon heating.",
    apparatus: "test_tube",
    reagents: [
      { id: "ammonium", name: "Ammonium Chloride", color: "#9ca3af", state: "solid", icon: "powder" },
    ],
    tools: [{ id: "heat", name: "Bunsen Burner", color: "#f97316", state: "energy", icon: "fire" }],
    steps: [
      "Place ammonium chloride in test tube.",
      "Heat gently and observe sublimation.",
    ],
    outputs: { ammonium: "NH₄Cl vaporizes and reforms on cooler surfaces." },
    effects: [{ id: "smoke", name: "White Vapors", color: "#4f4559", icon: "crystal" }],
  },
  {
    id: "combustion_hydrocarbon",
    title: "Combustion of Hydrocarbon",
    description: "Demonstrate clean blue flame of methane combustion.",
    apparatus: "beaker",
    reagents: [
      { id: "methane", name: "Methane Gas", color: "#9ca3af", state: "gas", icon: "bubbles" },
      { id: "oxygen", name: "Oxygen", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    steps: ["Supply methane to a burner.", "Observe clean blue flame."],
    outputs: { methane: "CH₄ + 2O₂ → CO₂ + 2H₂O + heat." },
    effects: [{ id: "fire", name: "Combustion Flame", color: "#fb923c", icon: "fire" }],
  },
  {
    id: "oxidation_reduction",
    title: "Oxidation-Reduction Reaction",
    description: "Show reaction between CuO and H₂.",
    apparatus: "test_tube",
    reagents: [
      { id: "cuo", name: "Copper Oxide (Black)", color: "#4b5563", state: "solid", icon: "powder" },
      { id: "hydrogen", name: "Hydrogen Gas", color: "#9ca3af", state: "gas", icon: "bubbles" },
    ],
    steps: ["Pass H₂ gas over heated CuO.", "Observe black solid turning brown."],
    outputs: { cuo: "CuO + H₂ → Cu + H₂O (reduction of CuO)." },
    effects: [{ id: "colorChange", name: "Color Change", color: "#f59e0b", icon: "crystal" }],
  },
  {
    id: "precipitation_reaction",
    title: "Precipitation Reaction Example",
    description: "Mix NaCl and AgNO₃ to form white AgCl precipitate.",
    apparatus: "beaker",
    reagents: [
      { id: "nacl", name: "Sodium Chloride Solution", color: "#e0f2fe", state: "liquid", icon: "droplet" },
      { id: "agno3", name: "Silver Nitrate Solution", color: "#824857", state: "liquid", icon: "bottle" },
    ],
    steps: ["Mix NaCl and AgNO₃ in a beaker.", "Observe white precipitate formation."],
    outputs: { agno3: "AgCl white precipitate formed." },
    effects: [{ id: "precipitate", name: "White Precipitate", color: "#e2e8f0", icon: "crystal" }],
  },
  {
    id: "gas_evolution",
    title: "Gas Evolution Reaction",
    description: "Reaction between zinc and dilute sulphuric acid.",
    apparatus: "test_tube",
    reagents: [
      { id: "zinc", name: "Zinc", color: "#a3a3a3", state: "solid", icon: "ingot" },
      { id: "acid", name: "Dilute H₂SO₄", color: "#ef4444", state: "liquid", icon: "droplet" },
    ],
    steps: ["Add zinc granules to acid.", "Observe hydrogen gas evolution."],
    outputs: { acid: "Hydrogen gas evolved with bubbling." },
    effects: [{ id: "bubbles", name: "Gas Bubbles", color: "#93c5fd", icon: "bubbles" }],
  },
  {
    id: "chemical_equilibrium_demo",
    title: "Chemical Equilibrium Demonstration",
    description: "Show dynamic equilibrium using potassium chromate and dichromate system.",
    apparatus: "beaker",
    reagents: [
      { id: "k2cr2o7", name: "Potassium Dichromate Solution", color: "#f97316", state: "liquid", icon: "bottle" },
      { id: "acid", name: "Dilute H₂SO₄", color: "#ef4444", state: "liquid", icon: "droplet" },
      { id: "base", name: "NaOH Solution", color: "#4ade80", state: "liquid", icon: "droplet" },
    ],
    steps: [
      "Add acid to dichromate — color changes from yellow to orange.",
      "Add base — color returns to yellow.",
    ],
    outputs: { k2cr2o7: "Dynamic equilibrium shift observed via color change." },
    effects: [{ id: "colorChange", name: "Reversible Color Change", color: "#fb923c", icon: "crystal" }],
  },
],
};

export default CHEMISTRY_EXPERIMENTS;
